// The Plan room's cast cards, from SuiteModel (`StoryEntity.shortName`, StoryModel.swift) and the app
// (`LibraryModel.studiedCharacter(of:)`, PhonePlanPage.swift; `CastCard`, StructureViews.swift): a character's study page
// on the corkboard is a card for the character — their colour along the top, their portrait, their role and how many of
// the manuscript's scenes they're in — and every other card's foot names its point of view in a word or two.
import type { MetadataValue } from '../contract.ts';
import type { StoryEntity } from '../model/documents.ts';
import { CharacterStudy } from '../edit/storeEditor.ts';

import { shortName } from '../presence.ts';

export { shortName };

/** `LibraryModel.studiedCharacter(of:)`: the character whose study page a document is (its `character-study` field
 *  names them), if it's one and they're in the cast. */
export function studiedCharacter<E extends Pick<StoryEntity, 'id'>>(metadata: Record<string, MetadataValue> | null | undefined, entities: readonly E[]): E | null {
  const v = metadata?.[CharacterStudy.field];
  if (v?.type !== 'text' || v.value === '') return null;
  return entities.find((e) => e.id === v.value) ?? null;
}

/** A cast card's foot: "Not in the manuscript yet", "12 scenes", or "12 scenes · 4 as point of view". */
export function castCardLine(seen: { scenes: number; pov: number }): string {
  if (seen.scenes === 0) return 'Not in the manuscript yet';
  const scenes = `${seen.scenes.toLocaleString('en-US')} ${seen.scenes === 1 ? 'scene' : 'scenes'}`;
  return seen.pov > 0 ? `${scenes} · ${seen.pov.toLocaleString('en-US')} as point of view` : scenes;
}
